import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import KTTooltip from '../../KTTooltip';

KTFormSearch.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onSubmit: PropTypes.func,
  value: PropTypes.string,
  autoFocus: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  enableCheckValid: PropTypes.bool,
  isTouched: PropTypes.bool,
  isValid: PropTypes.bool,
  feedbackText: PropTypes.string,
};

function KTFormSearch({
  name,
  type = 'text',
  placeholder = '',
  disabled = false,
  className = '',
  onSubmit,
  value = '',
  autoFocus = false,
  onFocus,
  onBlur,
  enableCheckValid = false,
  isTouched = false,
  isValid = false,
  feedbackText = '',
}) {
  // MARK: --- Params ---
  const typingTimeoutRef = useRef(null);
  const [text, setText] = useState(value);
  useEffect(() => {
    setText(value);
  }, [value]);

  // MARK: --- Functions ---
  function handleTextChanged(e) {
    const value = e.target.value;
    setText(value);

    if (!onSubmit) {
      return;
    }

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    typingTimeoutRef.current = setTimeout(() => {
      onSubmit(value);
    }, 500);
  }

  return (
    <div>
      <div className={`input-icon ${className}`}>
        <KTTooltip text={!disabled && placeholder} offset={[0, 0]}>
          <input
            id={name}
            type={type}
            className={`form-control ${enableCheckValid ? `${isValid ? 'is-valid*' : 'is-invalid'}` : ''
              }`}
            placeholder={placeholder}
            autoFocus={autoFocus}
            value={text}
            onChange={handleTextChanged}
            autoComplete="off"
            onFocus={onFocus}
            onBlur={onBlur}
            disabled={disabled}
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          />
        </KTTooltip>

        <span className="ml-1">
          <i className="fal fa-search text-muted"></i>
        </span>
      </div>
      <>
        {enableCheckValid && isTouched && !_.isEmpty(feedbackText) && (
          <div className={`${isValid ? 'valid-feedback' : 'invalid-feedback'}`}>{feedbackText}</div>
        )}
      </>
    </div>
  );
}

export default KTFormSearch;
